/**
 * Centralized color scheme definitions for themeable components.
 * Used across Categories (blue) and Accounts (teal) views for consistent styling.
 */

const colorSchemes = {
  blue: {
    // Mail list colors
    unreadDot: 'bg-blueberry-500',
    selectedBg: 'bg-blueberry-50',
    selectedBorder: 'border-l-blueberry-500',
    hover: 'hover:bg-nightshade-50',
    
    // Button/action colors
    primary: 'bg-blueberry-600',
    primaryHover: 'bg-blueberry-700',
    text: 'text-blueberry-700',
    
    // Tab navigation (underline style)
    tabActive: 'border-blueberry-700 text-blueberry-700',
    tabInactive: 'border-transparent text-nightshade-500 hover:text-nightshade-700',
    tabActiveCount: 'text-blueberry-500',
    tabInactiveCount: 'text-nightshade-400',
    
    // Tab navigation (pills style)
    tabPillsActive: 'bg-nightshade-100 text-nightshade-900 shadow-sm',
    tabPillsInactive: 'text-nightshade-600 hover:bg-nightshade-50',
    tabPillsActiveCount: 'bg-nightshade-200 text-nightshade-900',
    tabPillsInactiveCount: 'bg-nightshade-200 text-nightshade-700',
    
    // Filter chips
    chipActive: 'bg-blueberry-600 text-white shadow-sm',
    chipActiveCount: 'bg-white/20 text-white',
    chipInactive: 'bg-white text-nightshade-600 border border-nightshade-200 hover:border-nightshade-300 hover:bg-nightshade-50',
    chipInactiveCount: 'bg-nightshade-100 text-nightshade-500',
  },
  teal: {
    // Mail list colors
    unreadDot: 'bg-matcha-600',
    selectedBg: 'bg-matcha-50',
    selectedBorder: 'border-l-matcha-600',
    hover: 'hover:bg-nightshade-50',

    // Button/action colors
    primary: 'bg-matcha-700',
    primaryHover: 'bg-matcha-800',
    text: 'text-matcha-700',

    // Tab navigation (underline style)
    tabActive: 'border-matcha-700 text-matcha-700',
    tabInactive: 'border-transparent text-nightshade-500 hover:text-nightshade-700',
    tabActiveCount: 'text-matcha-500',
    tabInactiveCount: 'text-nightshade-400',

    // Tab navigation (pills style)
    tabPillsActive: 'bg-nightshade-100 text-nightshade-900 shadow-sm',
    tabPillsInactive: 'text-nightshade-600 hover:bg-nightshade-50',
    tabPillsActiveCount: 'bg-nightshade-200 text-nightshade-900',
    tabPillsInactiveCount: 'bg-nightshade-200 text-nightshade-700',

    // Filter chips
    chipActive: 'bg-matcha-700 text-white shadow-sm',
    chipActiveCount: 'bg-white/20 text-white',
    chipInactive: 'bg-white text-nightshade-600 border border-nightshade-200 hover:border-nightshade-300 hover:bg-nightshade-50',
    chipInactiveCount: 'bg-nightshade-100 text-nightshade-500',
  },
} as const;

export type ColorScheme = keyof typeof colorSchemes;

/**
 * Get color scheme by name.
 * @param scheme - 'blue' for Categories view, 'teal' for Accounts view
 */
export function getColorScheme(scheme: ColorScheme) {
  return colorSchemes[scheme];
}
